/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SetPassword } from '../models/SetPassword';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SetPasswordService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns SetPassword
     * @throws ApiError
     */
    public setPasswordCreate({
        requestBody,
    }: {
        requestBody: SetPassword,
    }): CancelablePromise<SetPassword> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/set-password/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
